var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCanGamesTorchIcon = function SvgCanGamesTorchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 1080 1080",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ffcb05;\n      }\n\n      .st1 {\n        fill: #f8ab95;\n      }\n\n      .st2 {\n        fill: #ffe7a7;\n      }\n\n      .st3 {\n        fill: #ee202e;\n      }\n\n      .st4 {\n        fill: #2d6cb5;\n      }\n\n      .st5 {\n        fill: #fff;\n      }\n\n      .st6 {\n        fill: #a5b4dd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M945.4,633.2l109.5,18.6-460.1,360.3c25.7-119.9,89.6-412.2,89.5-442.4l172.5-149.7v107.8l202.2-92-113.5,197.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M485.2,1015c-25.6-119.6-93.4-413.8-93.2-445.1l-173.5-151.1v107.6c0,0-196.7-90.6-196.7-90.6l108.7,197.4-109.4,18.6,464.2,363.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M684.3,569.7c.1,23.4.3,173.7-11.6,296.1-5.7,58.9-35,112.9-81.6,149.3l-53,41.5-52.8-41.3c-46.6-36.5-75.9-90.5-81.6-149.3-11.8-122-11.7-272-11.6-296.1l-15-426.4,88.1,101.7,72.9-221.9,72.7,221.9,88.1-101.7-14.9,423.5v2.9c0,0,.2-.2.2-.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M856.7,658.6c-12.2,54.4-38.5,81.4-38.5,81.4,0,0,6.2-243.2,4.9-247.8l-105.6,98.1c-.8,75.6-1.6,195.5-13.3,292.3l270-210.9s-49.6-13.2-117.5-13.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M586.8,272.3s-114.1,112.4-167.6,251.7l-2.1-282.9,59.8,68.9,62.9-175.2,47.1,137.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M976.7,512.4l-70.6,121.4s-27.3-1.4-49.3,0v-73.9l120-47.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218.6,562.4v75.9c-18-2.7-37.5-3.8-52.6-4.6l-63.3-121.3,115.9,49.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M653.6,540.7l-2.3,65.6c-7.3,4.4-14.3,9.4-14.3,9.4,27.9,505.6-143.5,369.6-147.4,358.7,75.4,30.7,129.4-69.9,77-307.3-14.6,11.7-18.8,15.5-18.8,15.5,0,0-1.6-28.3,2.8-55.2,29.1-35,72.4-67.9,103-86.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M662.6,241.1c-1.9,32.5-9.1,268-9.1,268-20.4,13.1-80.5,54.6-108.3,87.2-33.2,39-46.8,57.4-36.9,108,7.7,39.4,41.7,72.8,49.1,124.9,10.7,75-14.7,133.9-85,127.2,36.1-12.4,74-69.6,27.8-155-8.5-15.8-56.8-83.4-64.3-102.5-14.3-36.4-59.1-144.2,226.8-457.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M461,931.8s24.6-16.4,29.7-38.5c5.1-22.1.9-45.2-7.5-64.6-8.4-19.4-54.1-92-54.1-92,0,0-1,47.8,6.3,107.7,7.4,59.9,25.6,87.4,25.6,87.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M359,596.5l7.1,3.2.5-19.7-62.9-52.3-1,32.4,7.2,4.4.2,17.4-63.8-36.9v97.6c68.5,14.5,87.8,43,87.8,43-61.3-30-165.9-23.2-231.6-13.9l275.1,217.1c-24.1-80.5-18.5-292.3-18.5-292.3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCanGamesTorchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/canGames-Torch-Icon.346a451a.svg";
export { ForwardRef as ReactComponent };